<template>
  <div class="page-container firefile-page">
    <div class="top-bar">
      <div class="search-left">
        <el-input
          v-model="searchForm.fileName"
          placeholder="请输入文件名称"
          clearable
          size="small"
          style="width: 180px; margin-right: 8px"
          @keyup.enter.native="handleQuery"
          @clear="handleQuery"
        />
        <dict-select
          v-model="searchForm.fileType"
          :dict-type="DICT_TYPE.FIREFILE_TYPE"
          placeholder="文件分类"
          clearable
          size="small"
          style="width: 160px; margin-right: 8px"
          @change="handleQuery"
        />
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <div class="action-right">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增文件</el-button>
      </div>
    </div>

    <div class="table-wrapper">
      <el-table v-loading="tableLoading" :data="tableData" border size="small" height="100%">
        <el-table-column prop="fileName" label="文件名称" min-width="180" align="center" show-overflow-tooltip/>
        <el-table-column label="文件分类" width="140" align="center">
          <template slot-scope="scope">
            <dict-tag :dict-type="DICT_TYPE.FIREFILE_TYPE" :value="scope.row.fileType" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" align="center" show-overflow-tooltip/>
        <el-table-column prop="createUserName" label="创建人" width="100" align="center"/>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="handlePreview(scope.row)">下载文件</el-button>
            <el-button type="primary" plain size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" plain size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        :current-page.sync="pagination.pageNo"
        :page-size.sync="pagination.pageSize"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 新增/编辑文件弹窗 -->
    <FirefileDialog
      :key="fileDialogKey"
      :visible.sync="dialogVisible"
      :file-uuid="currentFileUuid"
      :initial-record="currentRecord"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
// 服务
import { fireFileService } from './firefile.service';
// 工具函数
import { DICT_TYPE } from '@/features/components/dict/dictTypeKeys';
import { downloadFromApiBlobResponse } from '@/features/common/utils/downloadFileUtil.js';
import { formatDateTime } from '@/features/common/utils/dateTimeUtil.js';
// 组件
import FirefileDialog from './firefileDialog.vue';

export default {
  name: 'FireFileList',
  components: { FirefileDialog },
  data () {
    return {
      searchForm: {
        fileName: '',
        fileType: ''
      },
      DICT_TYPE,
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      currentFileUuid: null,
      currentRecord: null,
      fileDialogKey: 0
    };
  },
  methods: {
    loadData () {
      this.tableLoading = true;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize
      };
      fireFileService.queryPage(params).then(res => {
        const page = res.data || {};
        this.tableData = page.rows || [];
        this.pagination.total = page.total || 0;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    handleQuery () {
      this.pagination.pageNo = 1;
      this.loadData();
    },
    handleReset () {
      this.searchForm = { fileName: '', fileType: '' };
      this.handleQuery();
    },
    handleSizeChange () {
      this.pagination.pageNo = 1;
      this.loadData();
    },
    handleCurrentChange () {
      this.loadData();
    },
    handleAdd () {
      this.currentFileUuid = null;
      this.currentRecord = null;
      this.fileDialogKey += 1;
      this.$nextTick(() => { this.dialogVisible = true; });
    },
    handleEdit (row) {
      this.currentFileUuid = row.uuid;
      this.currentRecord = { ...row };
      this.fileDialogKey += 1;
      this.$nextTick(() => { this.dialogVisible = true; });
    },
    handleDialogSuccess () {
      this.loadData();
    },
    handlePreview (row) {
      if (!row.fileId) {
        this.$message.warning('该文件暂无可下载内容');
        return;
      }
      this.tableLoading = true;
      fireFileService.getFile(row.uuid).then(res => {
        downloadFromApiBlobResponse(res, row.fileName || '下载文件');
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    handleDelete (row) {
      this.$confirm(`确定删除文件「${row.fileName}」吗？删除后不可恢复。`, '删除确认', {
        type: 'warning',
        confirmButtonText: '确定删除',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        this.tableLoading = true;
        fireFileService.delete(row.uuid).then(() => {
          this.$message.success('删除成功');
          if (this.tableData.length === 1 && this.pagination.pageNo > 1) {
            this.pagination.pageNo -= 1;
          }
          this.loadData();
        }).finally(() => {
          this.tableLoading = false;
        });
      }).catch(() => {});
    },
    formatDateTime
  },
  created () {
    this.loadData();
  }
};
</script>

<style scoped lang="scss">
.firefile-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.search-left {
  display: flex;
  align-items: center;
}

.action-right {
  display: flex;
  align-items: center;
}

.table-wrapper {
  flex: 1;
  overflow: hidden;
}

.pagination-bar {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
}
</style>
